module.exports = __webpack_public_path__ + "static/img/logo.4ce8203d.png";